import { render, staticRenderFns } from "./priceFun.vue?vue&type=template&id=0854a24f&scoped=true"
import script from "./priceFun.vue?vue&type=script&lang=ts"
export * from "./priceFun.vue?vue&type=script&lang=ts"
import style0 from "./priceFun.vue?vue&type=style&index=0&id=0854a24f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0854a24f",
  null
  
)

export default component.exports